<template>
  <div
    class="pageBanner"
    :style="
      'background:url(' +
      info.url +
      ');background-position: center;background-repeat: no-repeat;'
    "
  >
    <div class="bannerContain">
      <div class="container">
        <h2>{{ info.title }}</h2>
        <p>{{ info.text }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="less" scoped>
.pageBanner {
  width: 100%;
  height: 900px;
  position: relative;
  .bannerContain {
    height: 100%;
    background: rgba(0, 0, 0, 0.25);
    .container {
      display: flex;
      height: 100%;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;

      h2 {
        font-size: 64px;
        color: #ffffff;
        margin-bottom: 30px;
      }
      p {
        font-size: 34px;
        color: #ffffff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/banner.vue